import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga/character-classes';

export const characterClassSkinApi = {
    store: async (characterClassId, body) => {
        const { data } = await http.post(`${API_PREFIX}/${characterClassId}/character-class-skins`, body, {});

        return data;
    },

    //PATCH and PUT Request Does not Working with form-data so I appended `_method=PUT`. Ref: https://stackoverflow.com/a/60781688/11297747
    update: async (characterClassId, characterClassSkinId, body) => {
        const { data } = await http.post(
            `${API_PREFIX}/${characterClassId}/character-class-skins/${characterClassSkinId}?_method=PUT`,
            body,
            {},
        );

        return data;
    },

    delete: async (characterClassId, characterClassSkinId) => {
        await http.destroy(`${API_PREFIX}/${characterClassId}/character-class-skins/${characterClassSkinId}`);
    },
};
